// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e6SH","label":"styles_label__go3AL"};